import Cookies from 'universal-cookie'

// const Platform = "AppQa"; // values AppDev, AppQa, Prod
export const HomePageName = 'Home Page - Content Coming Soon';
export const AcumenAdminName = 'acumen';

//const AppUri = "http://localhost:51437/api/";
//const AppUri = "http://localhost:59451/api/";
//const AppUri = "http://localhost:5000/api/";
//const AppUri = "http://api.devacumen.com/api/";
const AppUri = "https://testapi.a2acumen.com/api/";
//const AppUri = "https://acumenapi.a2acumen.com/api/";

const AcumenAPIURL = "https://api.apiacumen.com/"
const AcumenAPIKey = "uZtu9iISFC9VpKV3zzvEs1bb6LSAj3wW8EAGk1zI"
const TablePrefix = "Acumen";
//const TablePrefix = "acumen_prod_";
const app_link = "app.a2acumen.com";
//const cognito_client_id = "7k0q7lik8fcq8eipvvgs0h6179";
//const cognito_pool_id = "us-east-1_wqBaHj9hK";
const cognito_client_id = "6nmu5336jvhf5oh2osole6g1mb";
const cognito_pool_id = "us-east-1_dsjRcVmfI";

export const getUriPath = (path) => {
    return AppUri + path;
}

export const getTablePrefix = () => {
    return TablePrefix;
}

export const getAcumenAPIKey = () => {
    return AcumenAPIKey;
}

export const getAcumenAPIURL = (path) => {
    return AcumenAPIURL + path;
}

export const getCognitoClientId = () => {
    return cognito_client_id;
}

export const getCognitoPoolId = () => {
    return cognito_pool_id;
}

export const SecurityRoles = {
    user: "USER",
    customerAdmin: "CUSTADMIN",
    systemAdmin: "ACUMENADMIN",
    getRow(role){
        if (role === this.customerAdmin) {
            return "Administrator";
        }

        if (role === this.systemAdmin) {
            return "System Admin";
        }

        return "User";
    }
}

export const EmailManager = {
    itemName: 'email',
    getEmail(){
        var c = new Cookies();
        var t = c.get(this.itemName);
        console.log(t);
        return t;
    },
    signout() {
        var c = new Cookies();
        c.remove(this.itemName);
    },
    setEmail(email) {
        var c = new Cookies();
        c.set(this.itemName, email);
    }
}

export const AuthManager = {
    itemName: 'authToken',
    getToken(){
        var c = new Cookies();
        var t = c.get(this.itemName);
        //console.log(t);
        return t;
    },
    isAuthenticated() {
        if (this.getToken() === undefined)
        {
            if(sessionStorage.getItem("atkn") !== null)        
            {
               this.setToken(sessionStorage.getItem("atkn"));
               return true;      
            }
            else
            {
                return false;
            }
        }
        else
        {
            return true;
        }        
    },
    signout() {
        sessionStorage.clear();
        var c = new Cookies();
        c.remove(this.itemName);
    },
    setToken(token) {
        var c = new Cookies();
        c.set(this.itemName, token);
        sessionStorage.setItem('atkn',token);
    }
 };

 export const ApiHeaders = () => ({
    'Content-Type':'application/json',
    'cache-control':'no-cache',
    'pragma':'no-cache',
    'authorization':'bearer ' + AuthManager.getToken()
});

export const ApiHeadersNoToken = {
    'Content-Type':'application/json',
    'cache-control':'no-cache',
    'pragma':'no-cache'
};




// WEBPACK FOOTER //
// ./src/Components/Configuration/Config.js